import { Component, Injector, OnInit } from '@angular/core';
import { selectAllClosingWorkflows, WorkflowsActions, WorkflowsState } from '@modeso/aumico-lib-cpmm-fe';
import { WorkflowDto } from '@modeso/aumico-lib-cpmm-fe/src/lib/dtos/workflow-dto.interface';
import { WorkflowArea } from '@modeso/aumico-lib-cpmm-fe/src/lib/enums/workflow-area.enum';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { cloneDeep } from 'lodash-es';
import { BasePageComponent } from '../../../../pages/base.page';

@UntilDestroy()
@Component({
    selector: 'app-closing-workflow-overview',
    templateUrl: './closing-workflow-overview.page.html',
    styleUrls: ['./closing-workflow-overview.page.scss'],
})
export class ClosingWorkflowOverviewPage extends BasePageComponent implements OnInit {
    workflows: WorkflowDto[] = [];
    openCreateNewWorkflowDialog = false;
    openSelectWorkflowTemplateDialog = false;
    selectedWorkflowTemplateId: string | undefined;

    constructor(private injector: Injector, private workflowsStore: Store<WorkflowsState>) {
        super(injector);
    }
    override ngOnInit(): void {
        super.ngOnInit();

        // reset states
        this.workflowsStore.dispatch(WorkflowsActions.setSelectedWorkflowId({ workflowId: null }));
        this.workflowsStore.dispatch(WorkflowsActions.setSelectedWorkflowAsTemplateId({ workflowId: null }));

        this.actionsListener$.pipe(ofType(WorkflowsActions.workflowDeleted), untilDestroyed(this)).subscribe(() => {
            this.fireSuccessNotification({
                descriptionKey: 'Workflow deleted successfully.',
            });
        });

        this.actionsListener$
            .pipe(ofType(WorkflowsActions.workflowDeleteFailure), untilDestroyed(this))
            .subscribe((error) => {
                this.fireErrorMessage('Workflow delete failure.');
            });

        this.workflowsStore
            .select(selectAllClosingWorkflows)
            .pipe(untilDestroyed(this))
            .subscribe((workflows) => {
                this.workflows = cloneDeep<WorkflowDto[]>(workflows);
            });

        this.workflowsStore.dispatch(
            WorkflowsActions.loadWorkflows({ filter: { area: WorkflowArea.CLOSING_PROCESS } }),
        );
    }

    onSearchFilterChange(searchValue: string): void {
        this.workflowsStore.dispatch(
            WorkflowsActions.loadWorkflows({
                filter: { area: WorkflowArea.CLOSING_PROCESS, search: searchValue },
            }),
        );
    }

    selectWorkflowTemplate(name: string, disabled: boolean): void {
        if (!disabled) {
            this.selectedWorkflowTemplateId = name;
        }
    }

    editWorkflow(id: string): void {
        this.router.navigate([`../${id}`], { relativeTo: this.activatedRoute });
        this.workflowsStore.dispatch(WorkflowsActions.setSelectedWorkflowId({ workflowId: id }));
    }

    deleteWorkflow(id: string): void {
        this.workflowsStore.dispatch(WorkflowsActions.deleteWorkflow({ workflowId: id }));
    }

    createWorkflowFromScratch(): void {
        this.selectedWorkflowTemplateId = undefined;
        this.openCreateNewWorkflowDialog = false;
        this.openSelectWorkflowTemplateDialog = false;
        this.router.navigate([`../new`], { relativeTo: this.activatedRoute });
    }

    createWorkflowFromSelectedTemplate(): void {
        this.openCreateNewWorkflowDialog = false;
        this.openSelectWorkflowTemplateDialog = false;

        this.workflowsStore.dispatch(
            WorkflowsActions.setSelectedWorkflowAsTemplateId({ workflowId: this.selectedWorkflowTemplateId }),
        );

        this.router.navigate([`../new`], { relativeTo: this.activatedRoute });
    }
}
